import * as React from "react";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import Grid from "@mui/material/Grid/Grid";
import TextField from "@mui/material/TextField/TextField";
import MenuItem from "@mui/material/MenuItem";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Snackbar from "@mui/material/Snackbar/Snackbar";
import Alert from "@mui/material/Alert/Alert";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import firebase from "../../firebase/firebase";
import { useContext } from "react";
import { AuthUserContext } from "../../providers/AuthProvider";
import Spinner from "../../components/spinner";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Button from "@mui/material/Button/Button";
import Box from "@mui/material/Box/Box";
import { styled } from "@mui/material/styles";
import LinearProgress, {
	linearProgressClasses,
} from "@mui/material/LinearProgress";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PersonIcon from '@mui/icons-material/Person';
import PostNotification from "../../helpers/post-notification";
import NumberFormat from "../../helpers/number-format";
import DownloadFileHelper from "../../components/download-file-helper";

const storageRef = firebase.storage().ref();

function ProjectShowInterest() {
	const [open, setOpen] = React.useState(false);
	const [openToaster, setOpenToaster] = React.useState(false);
	const [funding, setFunding] = React.useState(0);
 	const { profile } = useContext(AuthUserContext);
	const [reel, setProjectReel] = React.useState();
	const [projCover, setProjCover] = React.useState()
	const [project, setProject] = React.useState();
	const [activeTab, setTab] = React.useState("overviews");
	const [statuses, setStatuses] = React.useState({});
	const [financial, setFinancial] = React.useState([]);
	const [mainCasts, setMainCasts] = React.useState([]);
	const [casts, setCasts] = React.useState([]);
	const [loading, setLoading] = React.useState(true);
	const [isNDA, setIsNDA] = React.useState(false);
	const [autoplay, setAutoplay] = React.useState(false);
	const [playing,setPlaying] = React.useState(false)
	const navigator = useNavigate();
	const dateConverter = (date) => {
		const [year, month, day] = date.split('-');
	
		const result = `${month}/${day}/${year}`;
		return result
	  }
	
	const setFinn = async (fanans) => {
		const list = [];
		for (let fan of fanans) {
			// const url = await downloadURL(fan.url);
			list.push({ ...fan, id: Math.random() });
			if (list.length === fanans.length) {
				setFinancial(list);
			}
		}
	};
	const setcsts = (casts, type) =>
		new Promise(async (resolve, reject) => {
			const list = [];
			for (let cast of casts) {
				const url = await downloadURL(cast.avatar);
				list.push({ ...cast, url, id: Math.random() });
				if (list.length === casts.length) {
					if (type === "main") {
						setMainCasts(list);
					} else {
						setCasts(list);
					}
					resolve("yes");
				}
			}
		});


  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = (tab) => {
    if( isNDA || (profile.userType === 'admin') || ((profile.userType === 'creator') && project.uid === profile.uid) ) {
      setTab(tab);
    } else {
      setOpen(true);
    }
  }

  const goToDashboard = () => {
    navigator('/investor/dashboard');
  }

  let { projectId } = useParams();

	const downloadURL = (url) =>
		new Promise((resolve, reject) => {
			if (url && url !== "") {
				const mediaRef = storageRef.child(url);

				// Get the download URL
				mediaRef
					.getDownloadURL()
					.then((url) => {
						resolve(url);
						// setImageUrl(url)
						// setLoading(false)
						// Insert url into an <img> tag to "download"
					})
					.catch((error) => {
						reject(error);
						// setLoading(false)

						// A full list of error codes is available at
						// https://firebase.google.com/docs/storage/web/handle-errors
						switch (error.code) {
							case "storage/object-not-found":
								// File doesn't exist
								break;
							case "storage/unauthorized":
								// User doesn't have permission to access the object
								break;
							case "storage/canceled":
								// User canceled the upload
								break;

							// ...

							case "storage/unknown":
								// Unknown error occurred, inspect the server response
								break;
						}
					});
			} else {
				resolve(url);
			}
		});
	const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
		height: 30,
		borderRadius: 15,
		[`&.${linearProgressClasses.colorPrimary}`]: {
			backgroundColor:
				theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
		},
		[`& .${linearProgressClasses.bar}`]: {
			borderRadius: 5,
		},
	}));
	const projectRef = firebase
		.firestore()
		.collection("projects")
		.doc(projectId);
  const fundingCaculate = (t, budget) => {
    return 0;
    // return (t / budget) * 100
  }
  React.useEffect(() => {
    const receipts = firebase
      .firestore()
      .collection('receipts')
      .orderBy('createdAt', "desc")
      .where('projectId', '==', projectId)
      .get().then((receipts) => {
        if (receipts.size > 0) {
          let t = 0;
          for(let contract of receipts.docs){
            if (contract.data().amount && typeof parseInt(contract.data().amount) === 'number') {
              if (parseInt(contract.data().amount) != NaN) {
                t += parseInt(contract.data().amount);
              }
            }

          }
        //   console.log(t, 'TOTAL INVESTMENT')
          setFunding(t)
        }
      })
  }, [])
  React.useEffect(() => {

    let unsub ;
    if (projectId) {
      unsub = projectRef.get()
        .then(async (snapshot) => {
          setLoading(false);
					// console.log(snapshot.data().uid);
					const projectUser = await firebase
						.firestore()
						.collection("users")
						.where("uid", "==", snapshot.data().uid)
						.get();
					if (projectUser?.docs && projectUser?.docs.length > 0) {
						setProject({
							...snapshot.data(),
							name: projectUser?.docs[0].data().name,
						});
						if (
							snapshot?.data()?.contract &&
							snapshot?.data()?.contract?.millstones &&
							snapshot?.data()?.contract?.millstones.length > 0
						) {
							const sts = {};
							snapshot
								?.data()
								?.contract?.millstones.forEach(
									(d, i) => (sts[i] = d?.status || "-")
								);

              setStatuses(sts);
						}
						if (
							snapshot?.data()?.financial &&
							snapshot?.data()?.financial.length > 0
						) {
							setFinn(snapshot?.data()?.financial);
						}
						if (
							snapshot.data() &&
							snapshot.data()?.casts &&
							snapshot.data()?.casts.length > 0
						) {
							await setcsts(snapshot.data()?.casts, "cast");
						}
						if (
							snapshot.data() &&
							snapshot.data()?.mainCasts &&
							snapshot.data()?.mainCasts.length > 0
						) {
							await setcsts(snapshot.data()?.mainCasts, "main");
						}
					}

					if (snapshot.data().mediaFiles) {
						if (snapshot.data().mediaFiles.image) {
							const image = await downloadURL(snapshot.data().mediaFiles.image);
							setProjCover({src: image})
						}
						if (snapshot.data().mediaFiles.reel) {
							const image = await downloadURL(
								snapshot.data().mediaFiles.reel
							);
							setProjectReel({ src: image });
						}
					}
				})
				.catch((err) => setLoading(false));
		} else setLoading(false);
		return () => unsub;
  }, []);
  React.useEffect(() => {


    let query =  firebase.firestore().collection("NDA");

		query = query
			.where("projectId", "==", projectId)
			.where("uid", "==", profile?.uid);

		query
			.get()
			.then((ndaSnapshots) => {
				if (ndaSnapshots && ndaSnapshots?.size > 0) {
					setIsNDA(true);
				} else {
					setIsNDA(false);
				}
			})
			.catch((err) => {});
	}, []);
  const contactCreator = async () => {
    try {

      setLoading(true);
			const messageRef = await firebase.firestore().collection('messages');
      const roomRef = await firebase.firestore().collection("rooms");
			const getRoom = await roomRef
				.where("projectId", "==", projectId)
				.where("participates", "array-contains", profile?.uid)
				.get();
			if (getRoom && getRoom.size === 0) {
				const room = await roomRef.add({
					createdBy: profile.uid,
					participates: [project?.uid, profile.uid],
					updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
					createdAt: firebase.firestore.FieldValue.serverTimestamp(),
					projectId,
					projectTitle: project?.title,
				});
				const message = await messageRef.add(
          {
            text: `Please go ahead and upload your signed contract`,
            type: 'created-message',
            sender: profile?.uid,
            receiver: project?.uid,
            createdAt:firebase.firestore.FieldValue.serverTimestamp(),
            roomId: room?.id,
            read:false,
            status: 'send'
          }
        );

			}
			else{

					await roomRef.doc(getRoom.docs[0].id).update({
						updatedAt: firebase.firestore.FieldValue.serverTimestamp()
					})
				navigator("/artists/chat");
				}

			setLoading(false);
		} catch (e) {
			setLoading(false);
		}
	};
	if (loading) return <Spinner />;
	
	return (
		
		<React.Fragment>
			<GlobalStyles
				styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
			/>
			{/* Hero unit */}
			{/*<TopBar showBar={true}/s>*/}
			{profile?.userType === 'creator' ? 
				<Dialog
					maxWidth={"md"}
					open={open}
					onClose={handleClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title" >
						<Stack direction={'row'} spacing={2}>
						<Typography variant={'h6'} sx={{flex:1, fontSize:32, color:"#204488"}}>You cannot access this information</Typography>
						<IconButton sx={{color:'rgba(0, 0, 0, 0.87)'}} onClick={() => setOpen(false)}>
							<CloseIcon/>
						</IconButton>
						</Stack>
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description" >
						<Typography sx={{fontSize:16, color:"#363636"}} >You cannot access this information because only Investor who has signed NDA can access full project.</Typography>
						</DialogContentText>
					</DialogContent>
				</Dialog> : 
				<Dialog
					maxWidth={"md"}
					open={open}
					onClose={handleClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title" >
						<Stack direction={'row'} spacing={2}>
						<Typography variant={'h6'} sx={{flex:1, fontSize:32, color:"#204488"}}>You cannot access this information yet </Typography>
						<IconButton sx={{color:'rgba(0, 0, 0, 0.87)'}} onClick={() => setOpen(false)}>
							<CloseIcon/>
						</IconButton>
						</Stack>
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description" >
						<Typography sx={{fontSize:16, color:"#363636"}} >Without agreeing with the NDA, you cannot access the information. Would you like to send an NDA? This will take you to the next step</Typography>
						</DialogContentText>
					</DialogContent>
					<DialogActions sx={{paddingX: 3, paddingY: 2}}>
						<Button onClick={handleClose} size={'small'} sx={{paddingX: 3,color: '#204488', textDecoration:"underline"}}>Not Now</Button>
						{/* <Button  variant={'text'} color={'warning'} sx={{paddingX: 3, textDecoration:"underline"}} size={'small'} onClick={ goToDashboard} >
						Go to dashboard
						</Button> */}
						<Button  variant={'contained'} color={'warning'} sx={{paddingX: 3}} size={'small'} 
						onClick={ ()=> navigator(`/${profile?.userType === 'investor'? 'investor' : 'artists'}/nda-information-project/${projectId}`) } >
						Send Interest
						</Button>
					</DialogActions>
				</Dialog> 
			}
      <Container
				maxWidth="fullWidth"
				sx={{
					textAlign: "left",
					height: 552,
					padding: "0px !important",
				}}>
				{reel && (
					<video
					id="project-video"
					src={reel.src}
					style={{
						width: "100%",
						height: 570,
						objectFit: "cover",
					}}
					autoPlay={autoplay}
					controls={true}
					poster={projCover.src}
					onClick={() => setAutoplay(!autoplay)}
					onPlaying={(e)=> setPlaying(true)}
					onPause={(e)=> setPlaying(false)}
					/>
					)}
				<Typography sx={{color:"#ffffff", position:"absolute", top:600, left:"19%", transition:"0.2s ease-in", fontSize:"38px", mb:5, opacity: playing ? 0 : 1}}>{project && project.title}</Typography>
			</Container>
			<Container maxWidth="lg" sx={{ textAlign: "left", py: 5 }}>
				<Grid
					container
					direction={{ xs: "column", sm: "row" }}
					justifyContent="flex-start"
					alignItems="flex-start">
					<Grid item xs={12} sm={6} md={6}>
						<Stack  spacing={{ xs: 2, sm: 3.3 }}>
							<Typography sx={{fontSize: "16px", mt: 1.5, pb: 1}}>
								Director:{" "}
								{project && project.directors
									? project?.directors[0].director
									: "Andrew Lau"}
							</Typography>
							<Typography sx={{fontSize: "16px"}}>
								Posted:{" "}
								{moment(
									project?.createdAt.seconds * 1000
								).format("MMMM D, YYYY")}
							</Typography>
						</Stack>
					</Grid>
					<Grid item xs={12} sm={6} md={6}>
						<Stack
							direction={"column"}
							justifyContent="flex-start"
							alignItems="flex-end"
							spacing={{ xs: 2, sm: 3.3 }}>
							<Stack
								direction="row"
								justifyContent="flex-end"
								alignItems="center"
								spacing={5}>
								<Typography sx={{fontSize: "16px"}}>
									Investment
								</Typography>

								<Box
									sx={{
										py: 1,
										px: 7,
										backgroundColor: "#7DF0C0",
										borderRadius: "30px",
										width: 235,
										textAlign: "center",
									}}>
									<Stack direction="row"  justifyContent="center"
										   alignItems="center">
									<AttachMoneyIcon style={{fontSize:"25px"}}/>
										<Typography style={{fontSize:"20px"}}>
											{ project?.budget ? NumberFormat(+project?.budget) : ''
												// Intl.NumberFormat().format(project?.budget)
											}
										</Typography>

									
									</Stack>
								</Box>
							</Stack>
							<Stack
								direction="row"
								justifyContent="flex-end"
								alignItems="center"
								spacing={5}>
								<Typography sx={{fontSize: "16px"}}>
									Closing Date
								</Typography>
								<Box sx={{ width: 235, textAlign: "center" }}>
									{moment(project?.investmentDeadline).format(
										"MMMM D, YYYY"
									)}
								</Box>
							</Stack>
							<Stack
								direction="row"
								justifyContent="flex-end"
								alignItems="center"
								spacing={5}>
								<Typography sx={{fontSize: "16px"}}>
									Funding Progress
								</Typography>
								<Box sx={{ width: 235 }}>
									<BorderLinearProgress
										variant="determinate"
										value={funding && project && project.budget ? (funding / +project.budget) * 100 : 0}
										color={"success"}
									/>
								</Box>
							</Stack>
						</Stack>
					</Grid>
				</Grid>
			</Container>
			<Container
				maxWidth="full-width"
				component="main"
				sx={{ backgroundColor: "#204488", height: 60 }}>
				<Container
					maxWidth="lg"
					component="main"
					sx={{ textAlign: "left" }}>
					<Grid container direction="row" alignItems="center">
						<Grid sx={{ m: "10px 0px", width: "20%" }}>
							<Box
								sx={{
									backgroundColor:
										activeTab === "overviews"
											? "#fff"
											: "#ffffff000",
								}}>
								<Button
									sx={{
										width: "100%",
										height: 50,
										fontSize: "24px",
										color:
											activeTab === "overviews"
												? ""
												: "#fff",
										fontWeight:
											activeTab === "overviews"
												? 600
												: "",
									}}
									onClick={() => setTab("overviews")}>
									Overviews
								</Button>
							</Box>
						</Grid>
						<Grid sx={{ m: "10px 0px", width: "20%" }}>
							<Box
								sx={{
									backgroundColor:
										activeTab === "team"
											? "#fff"
											: "#ffffff000",
								}}>
								<Button
									sx={{
										width: "100%",
										height: 50,
										fontSize: "24px",
										color:
											activeTab === "team" ? "" : "#fff",
										fontWeight:
											activeTab === "team" ? 600 : "",
									}}
									onClick={() => handleClickOpen("team") }>
									Team
								</Button>
							</Box>
						</Grid>
						<Grid sx={{ m: "10px 0px", width: "20%" }}>
							<Box
								sx={{
									backgroundColor:
										activeTab === "script"
											? "#fff"
											: "#ffffff000",
								}}>
								<Button
									sx={{
										width: "100%",
										height: 50,
										fontSize: "24px",
										color:
											activeTab === "script"
												? ""
												: "#fff",
										fontWeight:
											activeTab === "script" ? 600 : "",
									}}
									onClick={() =>  handleClickOpen("script") }>
									Script
								</Button>
							</Box>
						</Grid>

						<Grid sx={{ m: "10px 0px", width: "20%" }}>
							<Box
								sx={{
									backgroundColor:
										activeTab === "financials"
											? "#fff"
											: "#ffffff000",
								}}>
								<Button
									sx={{
										width: "100%",
										height: 50,
										fontSize: "24px",
										color:
											activeTab === "financials"
												? ""
												: "#fff",
										fontWeight:
											activeTab === "financials"
												? 600
												: "",
									}}
									onClick={() =>  handleClickOpen("financials")  }>
									Financials
								</Button>
							</Box>
						</Grid>

						<Grid sx={{ m: "10px 0px", width: "20%" }}>
							<Box
								sx={{
									backgroundColor:
										activeTab === "millstones"
											? "#fff"
											: "#ffffff000",
								}}>
								<Button
									sx={{
										width: "100%",
										height: 50,
										fontSize: "24px",
										color:
											activeTab === "millstones"
												? ""
												: "#fff",
										fontWeight:
											activeTab === "millstones"
												? 600
												: "",
									}}
									onClick={() => handleClickOpen("millstones")}>
									Milestones
								</Button>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Container>
			{activeTab === "overviews" && (
				<Container maxWidth="lg" sx={{ textAlign: "left", py: 5 ,mt:-5}}>
					<Stack
						direction={"column"}
						justifyContent="flex-start"
						alignItems="flex-start"
						spacing={5}>
						<span />
						<Typography
							variant={"h5"}
							color={"primary"}
							sx={{
								borderBottom: "1px solid #204488",
								textTransform: "uppercase",
								width: "100%",
							}}>
							Logline
						</Typography>
						<Typography variant={"body"}>
							{project && project?.description
								? project?.description
								: "A group of doctors at a hospital in Wuhan, China are the first in the world to deal with a new disease, COVID-19."}
						</Typography>
						<span />
						<Typography
							variant={"h5"}
							color={"primary"}
							sx={{
								borderBottom: "1px solid #204488",
								textTransform: "uppercase",
								width: "100%",
							}}>
							Main cast
						</Typography>
						{/*
        TODO: main casts loop start           */}

						{mainCasts &&
							mainCasts.length > 0 &&
							mainCasts.map((d) => (
								<Stack
									key={d}
									direction={"row"}
									spacing={10}
									justifyContent="flex-start"
									alignItems="flex-end">
									<img
										src={d.url}
										style={{
											width: 150,
											height: 175,
											objectFit: "cover",
										}}
										alt=""
									/>
									<Typography color={"primary"} sx={{width:"200px"}}>
										{d.name}
									</Typography>
									<Typography>{d.role}</Typography>
								</Stack>
							))}
						<span />
						<span />

						<span />
						<span />
						{!isNDA && profile?.userType === "investor" && (
							<Stack
								direction={"row"}
								justifyContent="center"
								alignItems="center"
								sx={{ width: "100%" }}>
								<Button
									sx={{
										pt: 1.2,
										pb: 1.2,
										pl: 5,
										pr: 5,
									}}
									variant={"contained"}
									onClick={() =>
										navigator(
											`/investor/nda-information-project/${projectId}`
										)
									}>
									Send Interest
								</Button>
							</Stack>
						)}

						{profile?.userType === "artist" && (
							<Stack
								direction={"row"}
								justifyContent="center"
								alignItems="center"
								sx={{ width: "100%" }}>
								{!isNDA && (
									<Button
										sx={{
											pt: 1.2,
											pb: 1.2,
											pl: 5,
											pr: 5,
										}}
										variant={"contained"}
										onClick={() =>
											navigator(
												`/artists/nda-information-project/${projectId}`
											)
										}>
										See more info
									</Button>
								)}
							</Stack>
						)}
					</Stack>
				</Container>
			)}
			{activeTab === "team" && (
				<Container maxWidth="lg" sx={{ textAlign: "left", py: 5 }}>
					<Stack direction={"column"} spacing={8}>
						<Stack
							spacing={5}
							direction="column"
							justifyContent="center"
							alignItems="flex-start">
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{
									borderBottom: "1px solid #204488",
									textTransform: "uppercase",
									width: "100%",
								}}>
								DIRECTOR
							</Typography>

							<Grid container spacing={0.5}>
								{project.directors &&
									project?.directors?.length > 0 &&
									project?.directors.map((d) => (
										<Grid
											item
											xs={6}
											container
											direction="row"
											justifyContent="space-between"
											alignItems="center"
											sx={{ pr: 15, pb: 5 }}>
											<Stack direction="row">
											<Typography color={"primary"} sx={{width:"350px"}}>
												{d?.director}
											</Typography>

											<Typography>Director</Typography>
											</Stack>
										</Grid>
									))}
							</Grid>
						</Stack>

						<Stack
							spacing={5}
							direction="column"
							justifyContent="center"
							alignItems="flex-start">
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{
									borderBottom: "1px solid #204488",
									textTransform: "uppercase",
									width: "100%",
								}}>
								PRODUCER
							</Typography>

							<Grid container spacing={0.5}>
								{project.producers &&
									project?.producers?.length > 0 &&
									project?.producers.map((d) => (
										<Grid
											item
											xs={6}
											container
											direction="row"
											justifyContent="space-between"
											alignItems="center"
											sx={{ pr: 15, pb: 5 }}>
											<Stack direction="row">
											<Typography color={"primary"} sx={{width:"350px"}}>
												{d?.producer}
											</Typography>

											<Typography>Producer</Typography>
											</Stack>
										</Grid>
									))}
							</Grid>
						</Stack>

						<Stack
							spacing={5}
							direction="column"
							justifyContent="center"
							alignItems="flex-start">
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{
									borderBottom: "1px solid #204488",
									textTransform: "uppercase",
									width: "100%",
								}}>
								CINEMATOGRAPHER
							</Typography>
							<Grid container spacing={0.5}>
								{project.cinematographers &&
									project?.cinematographers?.length > 0 &&
									project?.cinematographers.map((d) => (
										<Grid
											item
											xs={6}
											container
											direction="row"
											justifyContent="space-between"
											alignItems="center"
											sx={{ pr: 15, pb: 5 }}>
											<Stack direction="row">
											<Typography color={"primary"} sx={{width:"350px"}}>
												{d?.cinematographer}
											</Typography>

											<Typography>
												Cinematographer
											</Typography>
											</Stack>
										</Grid>
									))}
							</Grid>
						</Stack>
						<Stack
							spacing={5}
							direction="column"
							justifyContent="center"
							alignItems="flex-start">
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{
									borderBottom: "1px solid #204488",
									textTransform: "uppercase",
									width: "100%",
								}}>
								Cast
							</Typography>
							<Grid container spacing={0.5}>
								{casts &&
									casts?.length > 0 &&
									casts.map((d) => (
										<Grid
											item
											xs={6}
											container
											direction="row"
											justifyContent="space-between"
											alignItems="flex-end"
											sx={{ pr: 15, pb: 5 }}>
											{ d.url ? 
												<img
													src={d.url}
													style={{
														width: 150,
														height: 175,
														objectFit: "cover",
													}}
												/> : <PersonIcon
												style={{
													width: 150,
													height: 175,
													objectFit: "cover",
													color: "#204488"
												}}
												>
												</PersonIcon>}
											<Typography color={"primary"}>{d?.name}</Typography>
										
											<Typography>{d?.character}</Typography>		
										</Grid>
									))}
							</Grid>
						</Stack>
					</Stack>
				</Container>
			)}
			{activeTab === "millstones" && (
				<Container maxWidth="lg" sx={{ textAlign: "left", py: 5 }}>
					<Typography variant={"h5"}>Milestones</Typography>
					<Stack direction={"column"} spacing={3}>
						<Stack
							direction={"row"}
							spacing={3}
							sx={{ width: "100%" }}>
							<Typography
								variant={"body1"}
								sx={{
									flex: 1,
									p: 1.75,
									textAlign: "center",
									fontWeight: 600,
								}}
								color={"primary"}>
								Description
							</Typography>
							<Typography
								variant={"body1"}
								sx={{
									p: 1.75,
									paddingX: 2,
									textAlign: "center",
									fontWeight: 600,
								}}
								color={"primary"}>
								Amount
							</Typography>
							<Typography
								variant={"body1"}
								sx={{
									p: 1.75,
									paddingX: 2.5,
									textAlign: "center",
									fontWeight: 600,
								}}
								color={"primary"}>
								Deadline
							</Typography>

							<Typography
								variant={"body1"}
								sx={{
									p: 1.75,
									paddingX: 6.5,
									textAlign: "center",
									fontWeight: 600,
								}}
								color={"primary"}>
								Status
							</Typography>
						</Stack>
						{project &&
							project?.contract &&
							project?.contract?.millstones &&
							project?.contract?.millstones.length > 0 &&
							project?.contract?.millstones.map((d, i) => (
								<Stack
									direction={"row"}
									spacing={3}
									sx={{ width: "100%" }}>
									<Typography
										variant={"body2"}
										sx={{
											flex: 1,
											backgroundColor: "#ECF3FF",
											border: "1px solid #ECF3FF",
											borderRadius: "0px",
											p: 1.75,
										}}
										color={"primary"}>
										{d?.description}
									</Typography>
									<Typography
										variant={"body2"}
										sx={{
											border: "1px solid #204488",
											borderRadius: "0px",
											p: 1.75,
											paddingX: 3.7,
										}}
										color={"primary"}>
										{Intl.NumberFormat().format(d?.amount)}
									</Typography>
									<Typography
										variant={"body2"}
										sx={{
											border: "1px solid #204488",
											borderRadius: "0px",
											p: 1.75,
											paddingX: 3.7,
										}}
										color={"primary"}>
										{dateConverter(d?.deadLine)}
										
									</Typography>
									{project?.uid !== profile.uid ? (
										<Typography
											variant={"body2"}
											sx={{
												border: "1px solid #204488",
												textAlign: "center",
												borderRadius: "0px",
												p: 1.75,
												paddingX: 3.7,
												minWidth: 150,
											}}
											color={"primary"}>
											{d?.status}
										</Typography>
									) : (
										<TextField
											variant={"outlined"}
											color={"primary"}
											select
											value={statuses[i]}
											sx={{ minWidth: 150, }}
											size={"md"}
											onChange={(e) => {
												if (
													e.target.value &&
													e.target.value
												) {
													const sts = { ...statuses };
													sts[i] = e.target.value;
													setStatuses(sts);
													const millstones =
														project?.contract
															?.millstones;
													millstones[i].status =
														e.target.value;

													projectRef
														.update({
															"contract.millstones":
																millstones,
														})
														.then((d) => {
															setOpenToaster(true);
														});
													if (
														e.target.value !==
														"Yet to start"
													) {
														const projectNew = {
															id: projectId,
															...project,
														};
														const stateObject = {
															state: {
																project:
																	projectNew,
																tab: 3,
															},
														};
														PostNotification({
															title: "Milestone status update",
															text: "A milestone was updated. Click here to review and release funds.",
															uid: null,
															createdBy: "self",
															showing: ["super"],
															link: "/admin/project-management",
															state: JSON.stringify(
																stateObject
															),
														}).then();
													}
												}
											}}>
											<MenuItem value={"Completed"}>
												<Typography variant={"body2"}>
													{" "}
													Completed
												</Typography>{" "}
											</MenuItem>
											<MenuItem value={"Yet to start"}>
												<Typography variant={"body2"}>
													{" "}
													Yet to start
												</Typography>{" "}
											</MenuItem>
											<MenuItem value={"In progress"}>
												<Typography variant={"body2"}>
													{" "}
													In progress
												</Typography>{" "}
											</MenuItem>
										</TextField>
									)}
								</Stack>
							))}
					</Stack>
					<Snackbar
						open={openToaster}
						autoHideDuration={60000}
						anchorOrigin={{ vertical: "top", horizontal: "right" }}
						onClose={() => setOpenToaster(false)}>
						<Alert
							onClose={() => setOpenToaster(false)}
							severity={"info"}
							sx={{ width: "100%" }}>
							Millstone successfully update status
						</Alert>
					</Snackbar>
				</Container>
			)}
			{activeTab === "financials" && (
				<Container maxWidth="lg" sx={{ textAlign: "left", py: 5 }}>
					<Stack direction={"column"} spacing={8}>
						{financial &&
							financial.length > 0 &&
							financial.map((d) => (
								<Stack
									spacing={5}
									direction="column"
									justifyContent="center"
									alignItems="flex-start">
									<Typography
										variant={"h5"}
										color={"primary"}
										sx={{
											borderBottom: "1px solid #204488",
											textTransform: "uppercase",
											width: "100%",
										}}>
										{d?.type}
									</Typography>
									<Typography
										variant={"body1"}
										sx={{ lineHeight: 1.6 }}
										color={"text.secondary"}>
										Download this excel sheet for Analysis
									</Typography>
									<Button
										variant={"outlined"}
										color={"primary"}
										startIcon={<FileDownloadOutlinedIcon />}

										target={"_blank"} onClick={() => DownloadFileHelper(d?.url)}>
										Download file
									</Button>
								</Stack>
							))}
					</Stack>
				</Container>
			)}
			{activeTab === "script" && (
				<Container maxWidth="lg" sx={{ textAlign: "left", py: 5 }}>
					<Stack direction={"column"} spacing={8}>
						<Stack
							spacing={5}
							direction="column"
							justifyContent="center"
							alignItems="flex-start">
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{
									borderBottom: "1px solid #204488",
									textTransform: "uppercase",
									width: "100%",
								}}>
								Information
							</Typography>
							<Stack
								spacing={10}
								direction="row"
								justifyContent="flex-start"
								alignItems="center"
								sx={{ width: "100%" }}>
								<Stack
									spacing={5}
									direction="row"
									justifyContent="flex-start"
									alignItems="center"
									sx={{ flex: 1 }}>
									<Typography
										color={"primary"}
										sx={{ minWidth: 150 }}>
										RATED:
									</Typography>
									<Typography variant={"body2"}>
										{project?.rating}
									</Typography>
								</Stack>
								<Stack
									spacing={5}
									direction="row"
									justifyContent="flex-start"
									alignItems="center"
									sx={{ flex: 1 }}>
									<Typography
										color={"primary"}
										sx={{ minWidth: 250 }}>
										Expected release date
									</Typography>
									<Typography variant={"body2"}>
									{ dateConverter(project?.releaseDate)}
										
									</Typography>
								</Stack>
							</Stack>
							<Stack
								spacing={10}
								direction="row"
								justifyContent="flex-start"
								alignItems="center"
								sx={{ width: "100%" }}>
								<Stack
									spacing={5}
									direction="row"
									justifyContent="flex-start"
									alignItems="center"
									sx={{ flex: 1 }}>
									<Typography
										color={"primary"}
										sx={{ minWidth: 150 }}>
										GENRE:
									</Typography>
									<Typography variant={"body2"}>
										{project?.genre &&
											project.genre.map((d) => d + ", ")}
									</Typography>
								</Stack>
								<Stack
									spacing={5}
									direction="row"
									justifyContent="flex-start"
									alignItems="center"
									sx={{ flex: 1 }}>
									<Typography
										color={"primary"}
										sx={{ minWidth: 250 }}>
										Location of film development
									</Typography>
									<Typography variant={"body2"}>
										{project?.primaryFilmLocation}
									</Typography>
								</Stack>
							</Stack>
							<Stack
								spacing={10}
								direction="row"
								justifyContent="flex-start"
								alignItems="center"
								sx={{ width: "100%" }}>
								<Stack
									spacing={5}
									direction="row"
									justifyContent="flex-start"
									alignItems="center"
									sx={{ flex: 1 }}>
									<Typography
										color={"primary"}
										sx={{ minWidth: 150 }}>
										BUDGET:
									</Typography>
									<Typography variant={"body2"}>
									{Intl.NumberFormat().format(project?.budget)}
									</Typography>
								</Stack>
								<Stack
									spacing={5}
									direction="row"
									justifyContent="flex-start"
									alignItems="center"
									sx={{ flex: 1 }}></Stack>
							</Stack>
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{
									borderBottom: "1px solid #204488",
									textTransform: "uppercase",
									width: "100%",
								}}>
								lOGLINE
							</Typography>
							<Typography
								variant={"body1"}
								sx={{ lineHeight: 1.6 }}
								color={"text.secondary"}>
								{project?.description}
							</Typography>
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{
									borderBottom: "1px solid #204488",
									textTransform: "uppercase",
									width: "100%",
								}}>
								PLOT
							</Typography>
							<Typography
								variant={"body1"}
								sx={{ lineHeight: 1.6 }}
								color={"text.secondary"}>
								{project?.plot}
							</Typography>
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{
									borderBottom: "1px solid #204488",
									textTransform: "uppercase",
									width: "100%",
								}}>
								GENRES & KEYWORDS
							</Typography>
							<Typography
								variant={"body1"}
								sx={{ lineHeight: 1.6 }}
								color={"text.secondary"}>
								{project?.tags &&
									project.tags.map((d) => d + ", ")}
								{project?.genre &&
									project.genre.map((d) => d + ", ")}
							</Typography>
						</Stack>
					</Stack>
				</Container>
			)}
			{isNDA && profile.userType === "artist" && (
				<Stack
					direction={"row"}
					justifyContent="center"
					mb={5}
					alignItems="center"
					sx={{ width: "100%" }}
					onClick={contactCreator}>
					<Button
						sx={{
							pt: 1.2,
							pb: 1.2,
							pl: 5,
							pr: 5,
						}}
						variant={"contained"}>
						Contact creator
					</Button>
				</Stack>
			)}
			{(profile.userType === "admin" ||
				profile.userType === "super-admin") && (
				<Stack
					direction={"row"}
					justifyContent="center"
					mb={5}
					alignItems="center"
					sx={{ width: "100%" }}
					onClick={() => navigator(-1)}>
					<Button
						sx={{
							pt: 1.2,
							pb: 1.2,
							pl: 5,
							pr: 5,
						}}
						variant={"contained"}>
						go back to project management
					</Button>
				</Stack>
			)}
		</React.Fragment>
	);
}
export default ProjectShowInterest;
